import { env } from '@huggingface/transformers'

// 100% local: do NOT hit the internet
env.allowLocalModels = true
env.allowRemoteModels = false

// Where your local models live (under /public)
env.localModelPath = '/models/'

// Point ONNX Runtime to your local .wasm files
env.backends.onnx.wasm.wasmPaths = '/ort/'

// Optional: if you want to force WASM threads off/on, etc.
// env.backends.onnx.wasm.numThreads = 4;
